import { render, staticRenderFns } from "./jobTransfer.vue?vue&type=template&id=5aaf5a3c&scoped=true&"
import script from "./jobTransfer.vue?vue&type=script&lang=js&"
export * from "./jobTransfer.vue?vue&type=script&lang=js&"
import style0 from "./jobTransfer.vue?vue&type=style&index=0&id=5aaf5a3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaf5a3c",
  null
  
)

export default component.exports